import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyframe: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconKeyframe"><Path d="M12.0001 1.18945L1.18945 12.0001L12.0001 22.8108L22.8108 12.0001L12.0001 1.18945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyframe;
